import { AnalyticsOrderType } from '../../constants/analytics';

export const analyticsTopSellersUtils = {
  getDataKeyFromCurrentOrderType,
  getTitle,
};

function getDataKeyFromCurrentOrderType(currentOrderType) {
  if (currentOrderType === AnalyticsOrderType.ORDERS) return 'orders';
  if (currentOrderType === AnalyticsOrderType.UNITS) return 'units';
  if (currentOrderType === AnalyticsOrderType.SALES) return 'gmv';

  console.warn(`getDataKeyFromCurrentOrderType - Unexpected order type: ${currentOrderType}`);

  return 'units';
}

function getTitle(data = []) {
  const title = 'Best sellers by channels';
  const shouldAddNumberBeforeTitle = data.length > 0;

  return shouldAddNumberBeforeTitle ? `${data.length} ${title}` : title;
}
